namespace JupitersChoice {
    export class ShowBaseGameCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;

        execute(): void {
            const jupiterBaseGame = this._componentManager.get('JupiterBaseGame');

            this._layerManager.setVisibility('BaseGame', true);
            this._layerManager.setVisibility('BaseGameJupiter', true);

            jupiterBaseGame.changeAnimation('idle', false, true);
            jupiterBaseGame.resume();
            this._componentManager.get('BaseGameSky').changeAnimation('idle', false, true);
            this._componentManager.get('BaseGameSky').play();

            this._componentManager.get('JupiterLightningBolt').rotate((Math.PI / 180) * 90);

            // start base game flames
            for (let i = 1; i < 3; i++) {
                this._componentManager.get(`BaseGameFlame${i}`).show();
                this._componentManager.get(`BaseGameFlame${i}`).play();
            }

            // hide the damn reel glows
            TweenMax.delayedCall(0.01,() => {
                for (let i = 3; i < 6; i++) {
                    this._componentManager.get(`ReelGlow${i}`).hide();
                }
            });
        }
    }
}